import { cache, ZomentumStorageKeys } from "@/Contracts";

const nonEmpty = (value: string | null): string | null =>
	value && value.length > 0 ? value : null;

export const buildSuperOpsAuthorizeTarget = (): string => {
	const urlParams = new URLSearchParams(window.location.search);
	let cachedHint: string | null = null;
	try {
		cachedHint = cache.get(ZomentumStorageKeys.SUPEROPS_HINT, true) as
			| string
			| null;
	} catch {
		cachedHint = null;
	}
	const hint =
		nonEmpty(urlParams.get("superops_hint")) ??
		nonEmpty(urlParams.get("id_token_hint")) ??
		nonEmpty(cachedHint);

	const authorizePath = "/authorize";

	if (!hint) {
		return authorizePath;
	}

	const params = new URLSearchParams();
	params.set("superops_hint", hint);
	const region = urlParams.get("region");
	if (region) {
		params.set("region", region);
	}

	return authorizePath + "?" + params.toString();
};
